import { render, staticRenderFns } from "./ProfilRepeater.vue?vue&type=template&id=529dd617"
import script from "./ProfilRepeater.vue?vue&type=script&lang=js"
export * from "./ProfilRepeater.vue?vue&type=script&lang=js"
import style0 from "./ProfilRepeater.vue?vue&type=style&index=0&id=529dd617&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports